<script lang="ts">
    import {CommitsIcon} from "@anyways-open/common-svgs";
    import type { ToolBoxManager } from "../toolbox/ToolBoxManager";
    import type { ToolBoxViews } from "../../../scenario/test/ToolBoxViews";

    export let manager: ToolBoxManager<ToolBoxViews>;
    let openToolBox = manager.getOpenToolBoxStore();

    // click event, toggle layer on/off.
    const onClick = () => {
        if ($openToolBox === "commits") {
            $openToolBox = "none";
        } else {
            $openToolBox = "commits";
        }
    };

    const todo = () => {};
</script>

<div on:click={onClick} on:keydown={todo} class="btn btn-toolbox {$openToolBox == "commits" ? 'active' : ''}">
    <CommitsIcon class="toolbox-icon" />
</div>
